import { w as i } from "../internals/well-known-symbol-define.js";
import { s as e } from "../internals/symbol-define-to-primitive.js";
i("toPrimitive"), e();